/**
 * Build Widget Default Configuration
 *
 * Alternative build summary widget with different styling options.
 * Can be used in nested containers unlike Your Build.
 */

export interface BuildWidgetConfig {
  showTitle: boolean;
  title: string;
  showShareButton: boolean;
  shareButtonLabel: string;
  showShareIcon: boolean;
  showDescription: boolean;
  description: string;
  showAddToCartButton: boolean;
  addToCartButtonLabel: string;
  showAddToCartIcon: boolean;
  compactMode: boolean;
  showItemCount: boolean;
  showTotalPrice: boolean;
}

export const BUILD_DEFAULT_CONFIG: BuildWidgetConfig = {
  showTitle: true,
  title: 'Build',
  showShareButton: false,
  shareButtonLabel: 'Share',
  showShareIcon: false,
  showDescription: false,
  description: '',
  showAddToCartButton: true,
  addToCartButtonLabel: 'Add to Cart',
  showAddToCartIcon: false,
  compactMode: false,
  showItemCount: true,
  showTotalPrice: true,
};

/**
 * Create default configuration for a Build widget
 */
export const createBuildConfig = (): BuildWidgetConfig => ({
  ...BUILD_DEFAULT_CONFIG,
});

export default createBuildConfig;
